import { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { CouplePatient, CreateCouplePatientDTO } from "../../domain/CouplePatient";

export const CouplePatientAPI = {
    create: (data: CreateCouplePatientDTO): Promise<AxiosResponse<CouplePatient>> =>
        apiClient.post("/couple-patients/", data),

    async get(id: string) {
        return apiClient.get<CouplePatient>(`/couple-patients/${id}`);
    },

    listByTherapist: (therapistId: string): Promise<AxiosResponse<CouplePatient[]>> =>
        apiClient.get(`/couple-patients/therapist/${therapistId}`),

    delete: (id: string): Promise<AxiosResponse<void>> =>
        apiClient.delete(`/couple-patients/${id}`),
};
